"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _mixins = _interopRequireDefault(require("./mixins"));
var _default2 = exports.default = {
  name: 'wl-control',
  mixins: _mixins.default,
  props: {
    /* v-model */
    value: {
      type: String,
      default: ''
    },
    /* 表格是否是表单表格 */
    isForm: {
      type: Boolean,
      default: false
    },
    /* 组件参数设置 v-bind="options" */
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    formItemOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    control: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      controlValue: ''
    };
  },
  /* 计算属性 */
  computed: {
    getOptions: function getOptions() {
      var _listType, _a$_listType;
      var a = this.$$deepMerge(this.options, this.$attrs);

      // if (!a.is )
      switch (a.type) {
        case 'selector':
          a.is = 'wl-dialog-select';
          break;
        /* select 下拉框选择 */
        case 'select':
        case 'status':
          a.is = 'el-select';
          break;
        /* switch 开关 */
        case 'switch':
          a.is = 'el-switch';
          break;
        /* textarea 富文本 */
        case 'textarea':
          a.is = 'el-input';
          a.type = 'textarea';
          a.autosize = {
            minRows: 2,
            maxRows: 10
          };
          break;
        /* number 数字 */
        case 'num':
        case 'number':
          a.is = 'el-input-number';
          break;
        /* number 数字 */
        case 'time':
          a.is = 'el-time-picker';
          break;
        case 'year':
        case 'month':
        case 'date':
        case 'dates':
        case 'week':
        case 'datetime':
        case 'datetimerange':
        case 'daterange':
        case 'monthrange':
          a.is = 'el-date-picker';
          break;
        /* upload-image 上传图片 */
        case 'upload-image':
          a.type = 'images';
          (_a$_listType = a[_listType = 'list-type']) !== null && _a$_listType !== void 0 ? _a$_listType : a[_listType] = 'picture-card';
        /* upload 上传 */
        // eslint-disable-next-line no-fallthrough
        case 'upload':
          a.is = 'wl-upload';
          break;
        case 'rich-text':
          a.is = 'wl-rich-text';
          break;
        case 'provinces-cascader':
          a.is = 'wl-provinces-cascader';
          break;
        /* 金额数字输入框 */
        case 'price':
          a.is = 'wl-input-price';
          break;
        /* 默认 */
        default:
          a.is = 'el-input';
          break;
      }
      return this.$$deepMerge(this.options);
    },
    getMainOptions: function getMainOptions() {
      var a = this.$$deepMerge({}, this.formItemOptions);
      a.is = this.isForm ? 'el-form-item' : 'div';
      return (0, _objectSpread2.default)({}, a);
    }
  },
  watch: {
    value: {
      handler: function handler(nv) {
        // console.log('watch value', typeof nv, nv)
        this.controlValue = nv;
      },
      deep: true,
      immediate: true
    },
    controlValue: {
      handler: function handler(nv) {
        // console.log('watch controlValue', typeof nv, nv)
        this.$emit('input', nv);
      },
      deep: true
    }
  },
  methods: {
    init: function init() {
      this.controlValue = this.value;
      Object.assign(this.options, this.control);
    }
  },
  created: function created() {
    this.init();
  }
};